module.exports = __webpack_public_path__ + "img/sign-out-alt.8ec481dd.svg";